var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g(_vm._b({staticClass:"remove-button",attrs:{"disabled":_vm.disabled}},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_c('TrashIcon',{staticClass:"fill-current",class:{
      'text-grey': _vm.disabled,
      'text-red-500': !_vm.disabled,
    }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }